<template>
  <div class="container">
    <el-carousel class="top-notification" :height="carouselHeight" direction="vertical" v-if="noticeList.length>0" ref="carousel" @ready="updateHeight"
      @change="updateHeight">
      <el-carousel-item v-for="(item,index) in noticeList" :key="index">
        <div class="carousel-item" ref="marqueeItem">
          <img class="img-notification" src="../../../static/image/ic_notice.png" />
          <span class="span-notificatioon">{{item.noticeType == '2'?'【公告】':'【通知】'}}{{ item.noticeContent }}</span>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="my-swiper-container">
      <swiper v-if="swipers && swipers.length>0" class="my-swiper" ref="mySwiper"
        @slideChangeTransitionEnd="slideChangeEnd" @touchEnd='touchEnd' :options="swiperOptions">
        <swiper-slide v-for="(item,index) in swipers" :key="index">
          <div class="slide">
            <img :src='item.imageUrl' />
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-pagination">
        <img class="swiper-pagination-my"
          :src="index == swiperIndex?'../../../static/image/swiper_nav_1.png':'../../../static/image/swiper_nav_0.png' "
          v-for="(item,index) in swipers" />
      </div>
    </div>

    <div class="my-service-title-container">
      <div class="service-title-line"></div>
      <span class="title-one">我的服务</span>
      <span class="title-two">MY SERVICE</span>
    </div>
    <div class="my-serivce-container">
      <el-row class="el-row">
        <el-col :span="8">
          <div class="grid-content" @click="gridClick(1)">
            <img src="../../../static/image/jiankang.png" />
            <span class="item-service-title">健康预测</span>
            <div class="item-service-line"></div>
            <!-- <span class="item-serivce-desc">一句话描述</span> -->
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content" @click="gridClick(2)">
            <img src="../../../static/image/chayin.png" />
            <span class="item-service-title">茶饮</span>
            <div class="item-service-line"></div>

            <!-- <span class="item-serivce-desc">一句话描述</span> -->
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content" @click="gridClick(3)">
            <img src="../../../static/image/anmo.png" />
            <span class="item-service-title">经络调理</span>
            <div class="item-service-line"></div>
            <!-- <span class="item-serivce-desc">一句话描述</span> -->
          </div>
        </el-col>
      </el-row>
      <el-row class="el-row">
        <el-col :span="8">
          <div class="grid-content" @click="gridClick(4)">
            <img src="../../../static/image/zhenjiu.png" />
            <span class="item-service-title">针灸</span>
            <div class="item-service-line"></div>
            <!-- <span class="item-serivce-desc">一句话描述</span> -->
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content" @click="gridClick(5)">
            <img src="../../../static/image/zhongchengyao.png" />
            <span class="item-service-title">压片糖果</span>
            <div class="item-service-line"></div>
            <!-- <span class="item-serivce-desc">一句话描述</span> -->
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content" @click="gridClick(6)">
            <img src="../../../static/image/zhongyao.png" />
            <span class="item-service-title">中药组方</span>
            <div class="item-service-line"></div>
            <!-- <span class="item-serivce-desc">一句话描述</span> -->
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content" @click="gridClick(7)">
            <img src="../../../static/image/zinifang.png" />
            <span class="item-service-title">{{selfPrescriptionText}}</span>
            <div class="item-service-line"></div>
            <!-- <span class="item-serivce-desc">一句话描述</span> -->
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import {
    EventBus
  } from "../../js/eventbus.js"
  export default {
    components: {
      swiper,
      swiperSlide,
    },
    data() {
      return {
        swiperIndex: "1",
        carouselHeight:"32px",
        swiperOptions: {
          show_indicators: false,
          autoplay: true,
          effect: 'slide',
          slidesPerView: 'auto',
          centeredSlides: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'custom',
          },
        },
        swipers: [],
        noticeList: [],
        selfPrescriptionText:'自拟组方'
      }
    },
    created() {
      EventBus.$emit("refresh", 'home');

      this.wjtHttp.get(this, '/api/home/v1/carousel', {}, false, (res) => {
        var data = res.data
        if (data.code == 200) {
          this.swipers = data.data
        } else {
          this.$message({
            message: (data.msg && data.msg.length > 0) ? data.msg : '信息获取异常，请联系管理员',
            type: 'error'
          })
        }
      })
      this.wjtHttp.get(this, '/api/home/v1/notice', {}, false, (res) => {
        var data = res.data
        if (data.code == 200 && !this.utils.isEmptyStr(data.rows)) {
          this.noticeList = data.rows
          window.addEventListener('resize', this.updateHeight);
          this.updateHeight();
        }
      })
    },
    mounted() {
      console.log("home mounted")
      this.$store.commit('updateOrderData',{})
      this.$store.commit('updateFulfillmentConfirmData',{})
      var userInfo = this.$store.getters.getUserInfo
      if(userInfo && userInfo.selfTitle && userInfo.selfTitle.length > 0){
        this.selfPrescriptionText = userInfo.selfTitle
      }else{
        this.selfPrescriptionText = "自拟组方"
      }

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateHeight);
    },
    methods: {
      slideChangeEnd() {
        this.swiperIndex = parseInt(this.$refs.mySwiper.swiper.activeIndex)
      },
      touchEnd() {
        this.swiperIndex = parseInt(this.$refs.mySwiper.swiper.activeIndex)
      },
      gridClick(flag) {
        sessionStorage.removeItem('contactList')
        sessionStorage.removeItem('submitData')
        sessionStorage.removeItem('patient')
        sessionStorage.removeItem('consultInfo')
        sessionStorage.removeItem('visitRecordId')

        sessionStorage.removeItem('shangjiaoTableArray')
        sessionStorage.removeItem('zhongjiaoTableArray')
        sessionStorage.removeItem('xiajiaoTableArray')
        sessionStorage.removeItem('tablePrescription')
        sessionStorage.removeItem('prescription')
        sessionStorage.removeItem('fulfillmentDraftInfo')
        sessionStorage.removeItem('selectDrugList')
        sessionStorage.removeItem('handMakeInfo')
        sessionStorage.removeItem('checkActiveName')
        if (flag < 6) {
          this.$router.push({
            path: '/addServiceContact',
            query: {
              serviceIndex: flag
            }
          })
        } else {
          this.$router.push({
            path:'/addPrescriptionContact',
            query:{
              mode:flag == 6?1:2
            }
          })
        }
      },
      updateHeight() {
        this.$nextTick(() => {
          const marqueeItems = this.$refs.marqueeItem;
          if (marqueeItems.length > 0) {
            const maxHeight = Math.max(...marqueeItems.map(item => item.offsetHeight));
            this.carouselHeight = `${maxHeight}px`;
          }
        });
      }
    },
  }
</script>

<style scoped>
  .top-notification {
    width: 1366px;
    word-wrap: break-word;
    background: #FCF1D6;
    padding-left: 320px;
    padding-right: 320px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
  }

  .img-notification {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    position: relative;
    top: 1px;
  }

  .span-notificatioon {
    width: auto;
    height: 100%;
    display: flex;
    text-align: left;
    word-wrap: break-word;
    flex-direction: column;
    align-items: start;
    justify-content: center;
  }

  .carousel-item {
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .footer {
    height: 250px;
    width: 1366px;
    background: #414141;
    position: fixed;
    bottom: 0;
  }

  .my-swiper-container {
    height: 416px;
  }

  .my-swiper {
    outline: none;
    height: 416px;
    width: 1366px;
  }

  .swiper-button-prev {
    width: 37px;
    height: 69px;
    margin-bottom: 200px;
    top: 360px;
    left: 95px;
    background-image: url('../../../static/image/arrow_left.png');
  }

  .swiper-button-next {
    width: 37px;
    height: 69px;
    top: 360px;
    right: 95px;
    background-image: url('../../../static/image/arrow_right.png');
  }

  .swiper-pagination {
    bottom: 150px;
    width: 500px;
    top: 540px;
    left: calc(50% - 250px);
  }

  .swiper-pagination-my {
    width: 30px;
    height: 6px;
    margin-left: 6px;
    margin-right: 6px;
  }

  .my-service-title-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
  }

  .service-title-line {
    width: 36px;
    height: 5px;
    background: #333333;
    border-radius: 2.5px;
    margin-bottom: 10px;
  }

  .title-one {
    font-size: 40px;
    color: #333333;
    text-align: center;
  }

  .title-two {
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    text-align: center;
  }

  .my-serivce-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
  }

  .el-row {
    width: 1100px;
    height: auto;
  }

  .grid-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 56px;
    padding-top: 36px;
    cursor: pointer;
  }

  .grid-content>img {
    width: 206px;
    height: 206px;
  }

  .item-service-title {
    font-size: 18px;
    color: #333333;
    text-align: center;
    margin-top: 25px;
    font-weight: bold;
  }

  .item-service-line {
    width: 23px;
    height: 3px;
    background: #126FB3;
    border-radius: 1.5px;
    margin-top: 10px;
  }

  .item-serivce-desc {
    font-size: 14px;
    color: #333333;
    text-align: center;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/Home.vue